import React from 'react'
import styled from 'styled-components'
import {
  IconSearch as IconSearchBase,
  IconClose as IconCloseBase,
} from '@loadsmart/icons'

import { inputStyle } from './Input'

const Input = styled.input`
  ${inputStyle}
  border-radius: 30px;
  padding: 10px 35px;
  margin-bottom: -9px;
`
const IconSearch = styled(IconSearchBase)`
  position: relative;
  bottom: 18px;
  left: 10px;
  opacity: 0.5;
`
const IconClose = styled(IconCloseBase)`
  position: relative;
  left: calc(100% - 46px);
  bottom: 19px;
  cursor: pointer;
`

interface Props extends React.HTMLAttributes<HTMLInputElement> {
  value: React.ReactText
  disabled?: boolean
  onClear?(event: React.MouseEvent): void
}

export default function SearchBar({ onClear, ...props }: Props) {
  return (
    <>
      <Input type="text" {...props} />
      <IconSearch height={18} width={18} />
      {props.value && onClear && (
        <IconClose height={15} width={15} onClick={onClear} />
      )}
    </>
  )
}
